import { render, staticRenderFns } from "./DamageRequestItem.vue?vue&type=template&id=285df16a&"
import script from "./DamageRequestItem.vue?vue&type=script&lang=js&"
export * from "./DamageRequestItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports